import { useMutation, useQuery } from '@tanstack/react-query';

import contactService from 'services/contactService';

export const usePaymentTermsQuery = (options) => {
  return useQuery(
    ['customers', 'payment_terms'],
    () => contactService.paymentTerms.get(),
    options,
  );
};

export const useListFacilitiesQuery = (options) => {
  return useQuery(
    ['accounts', 'facilities', 'list'],
    () => contactService.accounts.facilities.list(),
    options,
  );
};

export const useListAccountsQuery = (options) => {
  return useQuery(
    ['accounts', 'list'],
    () => contactService.accounts.list(),
    options,
  );
};

export const useListContactsQuery = (options) => {
  return useQuery(
    ['contacts', 'list'],
    () => contactService.contacts.list(),
    options,
  );
};

export const useBulkEditContactsMutation = ({ ...options }) => {
  return useMutation(({ data }) => contactService.contacts.bulkUpdate(data), {
    onError: (error) => options.onError && options.onError(error),
    onSuccess: (data) => options.onSuccess && options.onSuccess(data),
  });
};

export const useBulkEditAccountsMutation = ({ ...options }) => {
  return useMutation(({ data }) => contactService.accounts.bulkUpdate(data), {
    onError: (error) => options.onError && options.onError(error),
    onSuccess: (data) => options.onSuccess && options.onSuccess(data),
  });
};

export const useBulkDeleteAccountsMutation = (options) => {
  return useMutation(
    (data) => contactService.accounts.bulkDelete(data),
    options,
  );
};

export const useBulkDeleteContactsMutation = (options) => {
  return useMutation(
    (data) => contactService.contacts.bulkDelete(data),
    options,
  );
};
